import { receiveStatus } from "./receiveStatus";

export const receiveType = {
	edi: "Edi",
	manual: "Manual",
	ediLikeAManual: "EdiLikeAManual",
	wasEdiLikeAManual: "WasEdiLikeAManual",
	transfer: "Transfer",
	unknown: "Unknown",
} as const;

export type ReceiveType = (typeof receiveType)[keyof typeof receiveType];

export function determineReceiveType(
	invoiceType?: string,
	recType?: string,
	purchaseOrderNumber?: string,
	invoiceNumber?: string,
	status?: string,
	isPartReceiveFeatureEnabled?: boolean,
	searchDataSource?: string
): ReceiveType | null {
	if (searchDataSource?.toLocaleLowerCase() === "Transfer".toLocaleLowerCase()) {
		return receiveType.transfer;
	}
	
	if (searchDataSource?.toLocaleLowerCase() === "VendorInvoice".toLocaleLowerCase()) {
		return receiveType.edi;
	}
	
	if (
		!recType &&
		invoiceType === "EDI" &&
		purchaseOrderNumber &&
		invoiceNumber &&
		status !== receiveStatus.open &&
		isPartReceiveFeatureEnabled
	) {
		return receiveType.ediLikeAManual;
	}

	if ((recType === receiveType.manual || invoiceType === "Manual") && purchaseOrderNumber) {
		return receiveType.manual;
	}
	if (
		(recType === receiveType.edi ||
			((!recType || recType === receiveType.wasEdiLikeAManual) && invoiceType === "EDI")) &&
		purchaseOrderNumber &&
		invoiceNumber
	) {
		return receiveType.edi;
	}
	if (
		(recType === receiveType.manual ||
			((!recType || recType === receiveType.wasEdiLikeAManual) && invoiceType === "Manual")) &&
		purchaseOrderNumber
	) {
		return receiveType.manual;
	}
	if (recType === receiveType.ediLikeAManual && purchaseOrderNumber && invoiceNumber) {
		return receiveType.ediLikeAManual;
	}
	if (!recType && invoiceType === "EDI" && purchaseOrderNumber && !invoiceNumber) {
		return receiveType.ediLikeAManual;
	}
	return null;
}

export function getBasePathForReceiveType(receiveTypeValue: ReceiveType): string | null {
	switch (receiveTypeValue) {
		case receiveType.edi:
			return "/receiving";
		case receiveType.ediLikeAManual:
			return "/edilikeamanualreceiving";
		case receiveType.manual:
			return "/manualreceiving";
		case receiveType.transfer:
			return "/transfers";
		default:
			return null;
	}
}
